import { Link } from "react-router-dom";
import FadeIn from "@/components/FadeIn";
import { IMG } from "@/data/images";

const STATS = [
  { num: "15+", label: "Ani de Experiență" },
  { num: "200+", label: "Proiecte Finalizate" },
  { num: "35", label: "Specialiști în Echipă" },
  { num: "98%", label: "Clienți Satisfăcuți" },
];

const SERVICES = [
  {
    icon: "🏠",
    title: "Construcție la Roșu",
    desc: "Fundație, structură, zidărie și acoperiș executate conform normativelor în vigoare.",
  },
  {
    icon: "🏡",
    title: "Construcție la Cheie",
    desc: "Predăm locuința complet finisată, gata de mutat, fără bătăi de cap.",
  },
  {
    icon: "🏘️",
    title: "Ansambluri Rezidențiale",
    desc: "Proiectăm și construim complexe de locuințe cu infrastructură completă.",
  },
  {
    icon: "🔨",
    title: "Renovări & Extinderi",
    desc: "Modernizăm și extindem locuințe existente păstrând structura originală.",
  },
];

const WHY_BULLETS = [
  "Experiență de peste 15 ani în construcții rezidențiale",
  "Materiale certificate și furnizori verificați",
  "Echipă proprie de muncitori calificați — fără subcontractori",
  "Respectăm termenele contractuale asumate",
  "Garanție 10 ani pentru structura de rezistență",
];

const TESTIMONIALS = [
  {
    text: "StructBuild ne-a construit casa la cheie în 14 luni, exact cum am stabilit. Calitate excepțională și o echipă serioasă la fiecare pas.",
    author: "Familia Gheorghiu, Iași",
  },
  {
    text: "Am ales StructBuild pentru vila noastră după ce am văzut alte proiecte ale lor. Nu am regretat nicio clipă — totul a fost transparent și profesionist.",
    author: "Mihai Tudorache, Pașcani",
  },
  {
    text: "Singurul constructor care a respectat termenul și bugetul. Le recomand oricui vrea să construiască serios.",
    author: "Elena Ciobanu, Iași",
  },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section className="sb-hero" data-testid="home-hero">
        <div className="sb-container">
          <div className="sb-hero-grid">
            <div>
              <div className="sb-hero-label">CONSTRUCȚII REZIDENȚIALE · IAȘI</div>
              <h1>Construim Visul Tău. Solid, La Timp, La Cheie.</h1>
              <p>
                StructBuild Construct este partenerul tău de încredere pentru construcția de
                case, vile și ansambluri rezidențiale în Iași și regiunile limitrofe. Calitate
                garantată, termene respectate.
              </p>
              <div className="sb-hero-cta">
                <Link to="/contact" className="sb-btn sb-btn-primary" data-testid="hero-cta-offer">
                  Solicită o Ofertă
                </Link>
                <Link to="/proiecte" className="sb-btn sb-btn-outline" data-testid="hero-cta-projects">
                  Vezi Proiectele Noastre
                </Link>
              </div>
            </div>
            <FadeIn className="sb-hero-image" delay={120}>
              <img
                src={IMG.hero}
                alt="Casă rezidențială modernă construită de StructBuild Construct"
                className="sb-img-cover"
                width="800"
                height="600"
                loading="eager"
              />
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="sb-stats" data-testid="home-stats">
        <div className="sb-container">
          <div className="sb-stats-grid">
            {STATS.map((s, i) => (
              <FadeIn key={s.label} delay={i * 80} data-testid={`stat-${i}`}>
                <div className="sb-stat-num">{s.num}</div>
                <div className="sb-stat-label">{s.label}</div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Services preview */}
      <section className="sb-section" style={{ background: "var(--sb-bg-light)" }} data-testid="home-services">
        <div className="sb-container">
          <FadeIn className="sb-section-header">
            <h2 className="sb-section-title">Ce Construim</h2>
            <p className="sb-section-subtitle">
              Soluții complete pentru proiecte rezidențiale de orice amploare
            </p>
          </FadeIn>
          <div className="sb-services-grid">
            {SERVICES.map((s, i) => (
              <FadeIn key={s.title} delay={i * 100}>
                <div className="sb-service-card" data-testid={`service-card-${i}`}>
                  <div className="sb-service-icon" aria-hidden="true">{s.icon}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <Link to="/servicii" className="sb-service-link">
                    Află mai mult <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Why us */}
      <section className="sb-section" data-testid="home-why">
        <div className="sb-container">
          <div className="sb-whyus-grid">
            <FadeIn className="sb-whyus-image">
              <img
                src={IMG.whyUs}
                alt="Echipa StructBuild Construct pe șantier"
                className="sb-img-cover"
                width="700"
                height="500"
                loading="lazy"
              />
            </FadeIn>
            <FadeIn delay={120}>
              <div className="sb-uppercase-label">DE CE STRUCTBUILD</div>
              <h2 className="sb-section-title" style={{ textAlign: "left", marginTop: "0.6rem" }}>
                Calitate Dovedită în Fiecare Proiect
              </h2>
              <ul className="sb-whyus-list">
                {WHY_BULLETS.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="sb-section" style={{ background: "var(--sb-bg-light)" }} data-testid="home-testimonials">
        <div className="sb-container">
          <FadeIn className="sb-section-header">
            <h2 className="sb-section-title">Ce Spun Clienții Noștri</h2>
          </FadeIn>
          <div className="sb-testimonials-grid">
            {TESTIMONIALS.map((t, i) => (
              <FadeIn key={t.author} delay={i * 110}>
                <div className="sb-testimonial-card" data-testid={`testimonial-${i}`}>
                  <div className="sb-quote-mark" aria-hidden="true">&ldquo;</div>
                  <p className="sb-testimonial-text">{t.text}</p>
                  <div className="sb-stars" aria-label="5 din 5 stele">⭐⭐⭐⭐⭐</div>
                  <div className="sb-testimonial-author">— {t.author}</div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* CTA banner */}
      <section className="sb-cta-banner" data-testid="home-cta">
        <FadeIn>
          <h2>Pregătit să Începi Construcția?</h2>
          <p>Contactează-ne astăzi pentru o consultație gratuită și o ofertă personalizată.</p>
          <Link to="/contact" className="sb-btn sb-btn-primary" data-testid="cta-contact-btn">
            Contactează-ne Acum <span aria-hidden="true">→</span>
          </Link>
        </FadeIn>
      </section>
    </div>
  );
}
